// extracted by mini-css-extract-plugin
export default {"productTextHeader":"DownloadButtonOS_productTextHeader__HDi2u","link":"DownloadButtonOS_link__elIcm"};